import { render } from "./KidsFitnessPage.vue?vue&type=template&id=dc626c60"
import script from "./KidsFitnessPage.vue?vue&type=script&lang=js"
export * from "./KidsFitnessPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__